/* Publications blog facet dropdowns (sections/main-blog.liquid, style "publications"): every
   <option> value is the /tagged/ URL for that pick, so choosing one navigates. Progressive:
   the chips beside each dropdown are plain links. */
(function () {
  'use strict';
  window.theme.register(function (root) {
    Array.prototype.forEach.call(root.querySelectorAll('select[data-facet-nav]'), function (sel) {
      sel.addEventListener('change', function () {
        if (sel.value) window.location.assign(sel.value);
      });
    });
  });
})();
